var exports = {
  "k": "xa15a2ab7--4edfb2--container",
};

module.exports = exports;
